const formatDisplayRunTime = (seconds: number) => {
  if (!seconds) return '';

  const hours = Math.floor(seconds / 60 / 60);
  const minutes = Math.floor((seconds / 60) % 60);

  if (hours === 0) {
    return `${minutes}m`;
  }

  return `${hours}h ${minutes}m`;
};

export default formatDisplayRunTime;
